<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'pieChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        showLegend:{
            type:Boolean,
            default: true,
        },
        legName:{
            type:String,
            default:function(){
                return '';
            }
        },
        jump:{
            type:String,
            default:function(){
                return '';
            }
        },
        isLabelbr:{
            type:Boolean,
            default: false,
        },
        colorArr:{
            type: Array,
            default: function () {
                return ["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"]
            }
        }
    },
    mounted() {
        let that = this;
        that.init();
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        // 位置
        positionData () {
            let that = this;
            let num = '';
            num = that.showLegend == true ? '40%' : '50%';
            return num;
        },
        pieOption:function(){
            let _this = this;
            let labelShow = "{b} {d}%";
            if(_this.isLabelbr){
                labelShow = "{b}\n{d}%";
            }
            var option = {
                title: {
                    text: _this.legName,
                    top:'center',
                    left:'center',
                    textStyle: {
                        color: '#3d3d4c',
                        fontSize:22
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {c} ({d}%)",
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {
                //             title: '下载',
                //         }
                //     }
                // },
                color:_this.colorArr,
                
                legend: {
                    show:_this.showLegend,
                    orient : 'vertical',
                    right:'7%',
                    y: 'center',
                    itemGap: 20,
                    textStyle: { 
                        color: this.$route.query.api_secret?"#ffffff":"#4c4c4c"
                    } 
                },
                series: [{
                        name:'',
                        type: 'pie',
                        startAngle:0,
                        center:[_this.positionData(), '50%'],
                        radius: ['40%', '60%'],
                        label: {
                            normal: {
                                formatter: labelShow,
                                textStyle: {
                                    //color:'rgba(255,255,255,.7)',
                                    fontSize:13
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter : function (params) {                         
                                        return (params.percent - 0).toFixed(2) + '%'
                                    },
                                    
                                },
                                shadowBlur: 20,
                                shadowOffsetY: 4,
                                shadowColor: 'rgba(6, 69,147, 0.3)'
                            }
                        },
                        data:_this.dataArray
                    }
                ]
            }
            return option;
        },
        init(){
            let _this = this;
            let mychart = document.getElementById(_this.id);
            _this.$echarts.init(mychart).dispose();
            _this.chart = _this.$echarts.init(mychart);
            _this.chart.setOption(_this.pieOption());
            _this.chart.on('click', function (param) {
                let type = _this.jump;
                if(type != ''){//不为空需要跳转
                    _this.$parent.$refs.child.listJump(type,param.name);
                }
                
            });
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/pieChart.vue